import { Col, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import Header from "../../Authorized/Header";
import ClientAccount from "../ClientAccount";
import { NavLink } from "react-router-dom";
import Icon from "@ant-design/icons";
import EditIcon from "../../Utilities/EditIcon";
import ShieldIcon from "../../Utilities/ShieldIcon";
import ChangePasswordForm from "../../Forms/ChangePasswordForm";
import { Helmet } from "react-helmet";

const ClientProfile = (props) => {
  const [showProfile, setShowProfile] = useState(true);
  useEffect(() => {
    if (props.match.url === "/client/profile/account") {
      setShowProfile(true);
    } else {
      setShowProfile(false);
    }
  }, [props.match.url]);
  return (
    <Layout>
      <Header />
      <Helmet title="My Profile | Unicon" />
      <Layout.Content>
        <Col xl={{ span: 20 }} style={{ margin: "auto", marginTop: "2vh" }}>
          <Row justify="space-between">
            <Col
              xl={{ span: 4 }}
              style={{
                background: "#ffffff",
                borderRight: "1px solid #1565d8",
              }}
            >
              <Row
                style={{
                  padding: "2vh",
                }}
              >
                <NavLink
                  to="/client/profile/account"
                  activeStyle={{
                    fontWeight: "bold",
                    color: "#1565d8",
                  }}
                >
                  <Icon component={EditIcon} />
                  Edit Profile
                </NavLink>
              </Row>
              <Row
                style={{
                  padding: "2vh",
                }}
              >
                <NavLink
                  to="/client/profile/security"
                  activeStyle={{
                    fontWeight: "bold",
                    color: "#1565d8",
                  }}
                >
                  <Icon component={ShieldIcon} />
                  Password
                </NavLink>
              </Row>
            </Col>
            <Col xl={{ span: 20 }}>
              {showProfile ? (
                <Col xl={{ span: 24 }}>
                  <ClientAccount />
                </Col>
              ) : (
                <Col>
                  <ChangePasswordForm />
                </Col>
              )}
            </Col>
          </Row>
        </Col>
      </Layout.Content>
    </Layout>
  );
};

export default ClientProfile;
